<bp-hl-area-container [name]="titel">
	@if (!istKaPunkt) {
		<div class="alert alert-warning" data-testid="ka-maske-falsches-verfahren">
			Dieser Punkt ist keine Aufnahme nach der Bodenkundlichen Kartieranleitung. Die Maske wird
			deshalb nicht angezeigt; das Kartierverfahren steht beim Anlegen des Projekts fest.
		</div>
	} @else {
		<div class="touch-form">
			@for (feld of felder; track feld.id) {
				<div class="form-row">
					<div class="form-label-cell wrap-label" [title]="hinweis(feld)">{{ beschriftung(feld) }}</div>
					<div class="form-input-cell" style="grid-column: span 3;">
						@if (feld.art === 'zahl') {
							<wd-number-input [name]="name(feld)" [model]="zahl(feld)" (modelChange)="setze(feld, $event)" [nonEmpty]="pflicht(feld)"></wd-number-input>
						} @else {
							<wd-text-input [name]="name(feld)" [model]="text(feld)" (modelChange)="setze(feld, $event)" [nonEmpty]="pflicht(feld)"></wd-text-input>
						}
					</div>
				</div>
			}
		</div>
		<div class="ka-fusszeile" data-testid="ka-maske-fuss">{{ fussText }}</div>
	}
</bp-hl-area-container>
